import React, { useState, useEffect, useRef } from "react";
import { useUser } from "../../contexts/UserContext";

import "./Properties.css";
import {
  AddPropertyButton,
  ImportPropertyButton,
  ImportPropertyLoggiaButton,
  PropertiesTable,
  Loader,
} from "../../components";
import { PageStructure } from "../../pages";
import { Add, Task } from "@mui/icons-material";

const Properties = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <PageStructure>
      <h2>Properties</h2>

      {isLoading && <Loader />}
      {!isLoading && (
        <>
          {
            localStorage.getItem("legacy") === "false" &&
            <div
            style={{
              display: "flex",
              flexDirection: "row",
              overflow: "hidden",
              overflowX: "auto",
              gap: "10px",
            }}
          >
            <AddPropertyButton />
            <ImportPropertyButton 
                setIsLoading={setIsLoading}
            />
            <ImportPropertyLoggiaButton 
                setIsLoading={setIsLoading}
            />
          </div>}
          <PropertiesTable />
        </>
      )}
    </PageStructure>
  );
};

export default Properties;
